import { DbTable } from '../db-table';
import { HttpClient } from '@angular/common/http';
import { Invitation } from '../../../../core/_shared/models/Invitation';
import { WebApiService } from '../../WebApiService';
export class DbInvitations extends DbTable<Invitation> {
    constructor(private http: HttpClient,private webApi:WebApiService) {
        super(http,webApi, "invitations");
    }
}
